import React, { useMemo } from 'react';
import { Audio } from '../shared/components/Audio';
import { useParticipants } from '../shared/contexts/ParticipantsProvider';
import { useJoinSound } from '../shared/hooks/useJoinSound';
import { WaitingRoom } from './WaitingRoom';
import { Stack } from '@mui/material';
import { BasicTrayHOC } from '../hocs/BasicTrayHOC';

export const Container = ({
	children
}: {
	children: any
}) => {
	const { isOwner } = useParticipants() as any;

	useJoinSound();

	const roomComponents = useMemo(
		() => (
			<>
				{/* Show waiting room notification & modal if call owner */}
				{isOwner && <WaitingRoom />}
				{/* Tray buttons */}
				<BasicTrayHOC />
				{/* Audio tags */}
				<Audio />
			</>
		),
		[isOwner]
	);

	return (

		<Stack
			justifyContent={'space-between'}
			sx={{
				flex: `1 1 100%`,
				width: 1,
				minWidth: 0,
				height: 1,
			}}
		>
			{children}
			{roomComponents}
		</Stack>
	);
};
